module.exports = __webpack_public_path__ + "assets/img/qrcode.4eec531f.jpg";